module.exports = __webpack_public_path__ + "img/sm.bdd9891.svg";